import styled from 'styled-components';


const MainJoinButton = styled.button`
    font-size: 14px;
    letter-spacing: 1.9px;
    font-weight: 100;
    margin: 0.5em 0.5em 0.5em 0;
    padding: 12px 2em;
    color: white;
    background-color: #e50914;
    cursor: pointer;
    text-decoration: none;
    vertical-align: middle;
    font-family: Arial, sans-serif;
    border-radius: 2px;
    user-select: none;
    text-align: center;
    border: 0;
    //text-transform: uppercase;

    &:hover {
      background-color: #E53935;
    }
`;


export default MainJoinButton


// WEBPACK FOOTER //
// ./src/components/CustomerActions/_ActionButton.js